import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import api from "@/lib/api";
import PublicLayout from "@/components/layout/PublicLayout";

export default function Conteudos() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    document.title = "Conteúdos — Ana Paula Moraes";
    api.get("/courses/public").then((r) => setCourses(r.data || []));
  }, []);

  return (
    <PublicLayout>
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-3xl mb-16 fade-in-up">
            <div className="eyebrow mb-4">Conteúdos & jornadas</div>
            <h1 className="font-serif text-4xl md:text-6xl mb-6 leading-tight" style={{ color: "var(--text-primary)" }}>
              Caminhos para você assumir o <em className="italic" style={{ color: "var(--copper)" }}>papel principal</em>.
            </h1>
            <p className="text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
              Cursos, mentorias e videoaulas pensadas para mulheres que decidiram parar de esperar e começar a viver com clareza, identidade e direção.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {courses.map((c, i) => {
              const hasExternal = !!c.external_url;
              const ctaLabel = hasExternal ? "Quero participar" : "Acessar conteúdo";
              const CardCta = hasExternal ? (
                <a
                  href={c.external_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-sm font-medium"
                  style={{ color: "var(--copper)" }}
                  data-testid={`public-course-cta-${i}`}
                >
                  {ctaLabel} <ArrowRight size={14} />
                </a>
              ) : (
                <Link
                  to="/login"
                  className="inline-flex items-center gap-1 text-sm font-medium"
                  style={{ color: "var(--copper)" }}
                  data-testid={`public-course-cta-${i}`}
                >
                  {ctaLabel} <ArrowRight size={14} />
                </Link>
              );
              return (
                <div key={c.id} className="brand-card overflow-hidden fade-in-up" style={{ animationDelay: `${i * 100}ms` }} data-testid={`public-course-${i}`}>
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={c.cover_url} alt={c.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="p-7">
                    <div className="flex items-center gap-2 mb-2 text-xs uppercase tracking-widest" style={{ color: "var(--copper)" }}>
                      {hasExternal ? "Inscrições abertas" : c.is_public ? "Aberto na área de membros" : (<><Lock size={12} /> Acesso liberado pelo admin</>)}
                    </div>
                    <h3 className="font-serif text-xl mb-3" style={{ color: "var(--text-primary)" }}>{c.title}</h3>
                    <p className="text-sm leading-relaxed mb-5 line-clamp-3" style={{ color: "var(--text-secondary)" }}>{c.description}</p>
                    {CardCta}
                  </div>
                </div>
              );
            })}
            {courses.length === 0 && (
              <div className="col-span-full text-center py-20" style={{ color: "var(--text-secondary)" }}>
                Em breve, novos conteúdos.
              </div>
            )}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
